import axios from 'axios'

import store from '~/store'
import * as types from '../mutation-types'
import { createTheParametersOfTheUrl } from '../../plugins/helper'

// state
export const state = {
  loadingEventFireWithGlobalTotal: true,
  eventFireGlobalTotal: null,
  errorEventFireWithGlobalTotal: null,
}

// mutations
export const mutations = {
  [types.EVENT_FIRE_WITH_GLOBAL_TOTAL_START] (state) {
    state.loadingEventFireWithGlobalTotal = true
    state.eventFireGlobalTotal = null
    state.errorEventFireWithGlobalTotal = null
  },

  [types.EVENT_FIRE_WITH_GLOBAL_TOTAL_SUCCESS] (state, { event }) {
    state.loadingEventFireWithGlobalTotal = false
    state.eventFireGlobalTotal = event
    state.errorEventFireWithGlobalTotal = null
  },

  [types.EVENT_FIRE_WITH_GLOBAL_TOTAL_ERROR] (state, { error }) {
    state.loadingEventFireWithGlobalTotal = false
    state.eventFireGlobalTotal = null
    state.errorEventFireWithGlobalTotal = error
  },
}

export const actions = {
  async setEventFireWithGlobalTotal ({ commit }, { echo, params, url }) {
    try {
      commit(types.EVENT_FIRE_WITH_GLOBAL_TOTAL_START)

      const href = createTheParametersOfTheUrl(params)
      axios.get(`${url}${href}`)
        .catch(error => {
          commit(types.EVENT_FIRE_WITH_GLOBAL_TOTAL_ERROR, { error })
        })

      const { authUser } = store.getters
      echo.private(`with-global-total.${authUser.id}`)
        .listen(
          '.App\\Events\\WithGlobalTotalUpdateEvent',
          function (event) {
            commit(types.EVENT_FIRE_WITH_GLOBAL_TOTAL_SUCCESS, { event })
          },
        ).error((error) => {
          console.error(error)
        })
    } catch (error) {
      commit(types.EVENT_FIRE_WITH_GLOBAL_TOTAL_ERROR, { error })
    }
  },
}

// getters
export const getters = {
  loadingEventFireWithGlobalTotal: state => state.loadingEventFireWithGlobalTotal,
  eventFireGlobalTotal: state => state.eventFireGlobalTotal,
  errorEventFireWithGlobalTotal: state => state.errorEventFireWithGlobalTotal,
}
